import React, { Component, PropTypes } from 'react';
import DemoItem from './DemoItem';
import resources from './resources'

import translate from '../../i18n/translate';

class DemoGallery extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="linkDemo">
                {resources.map((item, index) =>
                    <DemoItem key = {index} DemoItemContent={item} test = {(link)=>{this.props.onTest(link)}}/>
                )}
            </div>
        );
    }
}

export default DemoGallery;


// WEBPACK FOOTER //
// ./client/components/DemoGallery.js